<section>
  <div class="is-flex gap-8 text-14 is-family-semiBold">
    <ng-container *ngIf="viewModel$ | async as vm">
      <ng-container *ngIf="vm.measureCards.length === 1">
        <app-icon [name]="vm.measureCards[0].icon" class="text-32"></app-icon>
        <app-text>{{ vm.measureCards[0].label | AsyncLang | async }}</app-text>
      </ng-container>
      <ng-container *ngIf="vm.measureCards.length > 1">
        <app-icon name="generic" class="text-32"></app-icon>
        <app-text>{{ 'common-app.__WEBAPP_HC_COMPARE_MULTI_PRODUCTS' | AsyncLang | async }}</app-text>
      </ng-container>
    </ng-container>
  </div>
</section>